if (!customElements.get('od-brand-tabs')) {
  customElements.define(
    'od-brand-tabs',
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll('.od-brands__tab');
        this.groups = this.querySelectorAll('.od-brands__group');
        this.searchInput = this.querySelector('#odSearchInput');
        this.headerFilter = this.querySelector('.header-filter-brands');
        this.clearButton = this.querySelector('.od-brands-search-clear');
        this.viewAll = this.querySelector('#view-all-brand');
        this.clearButtonv2 = this.querySelector('.od-brands-search-clear-v2');


        this.bindEvents();
        this.handleSticky();
      }
      handleSticky() {
        if (!this.headerFilter) return;

        const offsetTop = this.headerFilter.offsetTop;

        window.addEventListener('scroll', () => {
          if (window.scrollY > offsetTop) {
            this.headerFilter.classList.add('is-sticky');
          } else {
            this.headerFilter.classList.remove('is-sticky');
          }
        });
      }


      bindEvents() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const tabValue = tab.getAttribute('data-tab');
            const isActive = tab.classList.contains('od-brands__tab--active');

            if (isActive) {
              if (this.searchInput) this.searchInput.value = '';
              this.groups.forEach((group) => {
                group.style.display = 'block';

                const items = group.querySelectorAll('.od-brands__item');
                items.forEach((item) => {
                  item.style.display = 'flex';
                });
              });
              this.tabs.forEach((t) => t.classList.remove('od-brands__tab--active'));
            } else {
              if (this.searchInput) this.searchInput.value = '';
              this.groups.forEach((group) => {
                group.style.display = 'none';
                const items = group.querySelectorAll('.od-brands__item');
                items.forEach((item) => {
                  if (item.style.display === 'none') {
                    item.style.display = 'flex';
                  }
                });
              });

              this.tabs.forEach((t) => t.classList.remove('od-brands__tab--active'));
              const selectedGroup = this.querySelector(`.od-brands__group[data-tab-content="${tabValue}"]`);

              if (selectedGroup) {
                selectedGroup.style.display = 'block';

                requestAnimationFrame(() => {
                const headerHeight =
                  this.headerFilter?.offsetHeight || 0;

                const top =
                  selectedGroup.getBoundingClientRect().top +
                  window.pageYOffset -
                  headerHeight -
                  8; // spacing

                window.scrollTo({
                  top,
                  behavior: 'smooth',
                });
              });
              }
              tab.classList.add('od-brands__tab--active');
            }
            const viewAllBrandMessage = document.getElementById('view-all-brand');
            if (viewAllBrandMessage) {
              viewAllBrandMessage.style.display = 'block';
            }
            
            if (this.clearButton) {
              this.clearButton.style.display = 'block';
            }
          });
        });

        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.odSearchBrands());
        }

        if (this.clearButton) {
          this.clearButton.addEventListener('click', () =>
            this.clearSearch()
          );
        }
        if (this.clearButtonv2) {
          this.clearButtonv2.addEventListener('click', () =>
            this.clearSearch()
          );
        }
        if (this.viewAll) {
          this.viewAll.addEventListener('click', () =>
            this.clearSearch()
          );
        }
      }
      clearSearch() {
      if (this.searchInput) {
        this.searchInput.value = '';
      }

      this.groups.forEach((group) => {
        group.style.display = 'block';

        const items = group.querySelectorAll('.od-brands__item');
        items.forEach((item) => {
          item.style.display = 'flex';
        });
      });

      this.tabs.forEach((tab) =>
        tab.classList.remove('od-brands__tab--active')
      );

      const noResultsMessage = document.getElementById('no-results');
      if (noResultsMessage) {
        noResultsMessage.style.display = 'none';
      }
      const viewAllBrandMessage = document.getElementById('view-all-brand');
      if (viewAllBrandMessage) {
        viewAllBrandMessage.style.display = 'none';
      }
      if (this.clearButton) {
        this.clearButton.style.display = 'none';
      }
    }


      odSearchBrands() {
        const query = this.searchInput.value.trim().toLowerCase();
        const hasQuery = query.length > 0;
        let hasResults = false;

        this.groups.forEach((group) => {
          const items = group.querySelectorAll('.od-brands__item');
          let groupHasMatch = false;
          items.forEach((item) => {
            const content = item.textContent.toLowerCase();
            const match = hasQuery ? content.includes(query) : true;
            item.style.display = match ? 'flex' : 'none';

            if (match) {
              groupHasMatch = true;
              hasResults = true;
            }
          });
          group.style.display = groupHasMatch ? 'block' : 'none';

          const tab = this.querySelectorAll(`.od-brands__tab`);
          tab.forEach((item) => {
            if (item.classList.contains('od-brands__tab--active')) {
              item.classList.remove('od-brands__tab--active');
            }
          });
        });
        const noResultsMessage = document.getElementById('no-results');
        const viewAllBrandMessage = document.getElementById('view-all-brand');
        if (viewAllBrandMessage) {
          viewAllBrandMessage.style.display = 'block';
        }
        console.log('hasResults', hasResults);
        if (!hasResults) {
          noResultsMessage.style.display = 'block';
        } else {
          noResultsMessage.style.display = 'none';
        }
      }
    }
  );
}
